import {routerReducer } from 'react-router-redux';
import { combineReducers }  from 'redux';

//Reducers & store initialization
import user from './user.reducer';
import header from './header.reducer';
import profile from './profileSave.reducer';
import hideage from './hideAge.reducer';
import session from './session.reducer';
//import events from './sessions.reducer';
import search from './search.reducer';
import runner from './runner.reducer';


var globalReducer = combineReducers({user, header, profile, hideage, session, search, runner, routing: routerReducer});

export default globalReducer;
